export default {
  addFile: ({ state, commit }, file) => {
    const newFiles = [...state.files, file]
    commit("setFiles", newFiles)
  },
  deleteFile: ({ state, commit }, indexFile) => {
    const newFiles = state.files.filter((file, index) => index !== indexFile)
    commit("setFiles", newFiles)
  },
  updateFilesCannotBeRemoved: ({ state, commit }) => {
    const filesCannotBeRemoved = state.files
    filesCannotBeRemoved.forEach(file => {
      file.canBeRemoved = false
    })
    commit("setFiles", filesCannotBeRemoved)
  }
}
